import { DispatchEquipAlerts } from "../DispatchEquipAlerts";
import { PreassignmentStepper } from "../PreassignmentStepper";
import { Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutPreassignment extends Layout {
    layoutDispatchEquipAlerts: DispatchEquipAlerts;
    layoutPreassignmentStepper: PreassignmentStepper;
    tabEquipmentAlerts: Tab;
    tabPreassignment: Tab;
    tabsetPreassignment: Tabset;
}
